import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../common/components/dashboard_layout.component';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { VendorInvoiceTable } from './VendorInvoiceTable';
import styles from './vendor_invoice_management.module.css';

export const VendorInvoiceManagement = () => {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState('all-invoices');
  const permissionNames = useMemo(() => {
    try {
      const stored = localStorage.getItem('permissions');
      if (!stored) {
        return [];
      }
      const parsed = JSON.parse(stored);
      return Array.isArray(parsed) ? parsed.map((p) => p.name) : [];
    } catch (error) {
      console.error('Failed to parse permissions:', error);
      return [];
    }
  }, []);

  useEffect(() => {
    if (!permissionNames.includes('Vendor Invoice Management')) {
      navigate('/rov', { replace: true });
    }
  }, [permissionNames, navigate]);

  const handleBackClick = () => {
    navigate('/rov');
  };

  return (
    <>
      <DashboardLayout padding={true}>
        <div className={styles['vendor-invoice-container']}>
          {/* <div className={styles['vendor-invoice-header']}>
            <div className={styles['header-left']}>
              <div className={styles['back-icon-container']} onClick={handleBackClick}>
                <ArrowBackIosOutlinedIcon className={styles['back-icon']} />
              </div>
              <h1 className={styles['page-title']}>Invoice Management (Vendor)</h1>
            </div>
          </div> */}

          {/* Tabs and New Invoice Button */}
          <div className={styles['tabs-row']}>
            <div className={styles['tabs-container']}>
              <button
                className={`${styles['tab']} ${selectedTab === 'all-invoices' ? styles['tab-active'] : ''}`}
                onClick={() => setSelectedTab('all-invoices')}
              >
                Active Invoices
              </button>
              <button
                className={`${styles['tab']} ${selectedTab === 'reverted-invoices' ? styles['tab-active'] : ''}`}
                onClick={() => setSelectedTab('reverted-invoices')}
              >
                Closed Invoices
              </button>
            </div>
            <button
              className={styles['new-invoice-button']}
              onClick={() => navigate('/vendorInvoiceManagement/newInvoice')}
            >
              New Invoice
            </button>
          </div>

          <VendorInvoiceTable selectedTab={selectedTab} />
        </div>
      </DashboardLayout>
    </>
  );
};
